import { render, staticRenderFns } from "./AssignTherapist.vue?vue&type=template&id=c8742432&"
import script from "./AssignTherapist.vue?vue&type=script&lang=ts&"
export * from "./AssignTherapist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports